export enum MedicalDocumentType {
  Clinical = 'Clinical',
  Radiation = 'Radiation',
  Integrative = 'Integrative'
}
